<template>
  <form novalidate>
    <h4 class="h4 text--bold text--uppercase">Sobre la relación animales silvestres-perros</h4>

    <form-group :error="errors.has('mamiferosFrecuentes') && submitted">
      <label class="form__label form__label--required">
        16. ¿Cuáles son los dos mamíferos silvestres
        que se ven con mayor frecuencia en su propiedad?
      </label>
      <div class="checkbox checkbox--azul">
        <input :disabled="!editando" type="checkbox" id="tepezcuintletiposMamiferosMayFrec"
        v-model="form.tiposMamiferosMayFrec" value="Tepezcuintle"
        v-validate="'required'" name="mamiferosFrecuentes">
        <label class="form__label" for="tepezcuintletiposMamiferosMayFrec">Tepezcuintle</label>
      </div>
      <div class="checkbox checkbox--azul">
        <input :disabled="!editando" type="checkbox" id="sainotiposMamiferosMayFrec"
        v-model="form.tiposMamiferosMayFrec" value="Saíno (de collar)"
        v-validate="'required'" name="mamiferosFrecuentes">
        <label class="form__label" for="sainotiposMamiferosMayFrec">Saíno (de collar)</label>
      </div>
      <div class="checkbox checkbox--azul">
        <input :disabled="!editando" type="checkbox" id="chanchoMontetiposMamiferosMayFrec"
        v-model="form.tiposMamiferosMayFrec" value="Chancho de monte (cariblanco)"
        v-validate="'required'" name="mamiferosFrecuentes">
        <label class="form__label" for="chanchoMontetiposMamiferosMayFrec">
          Chancho de monte (cariblanco)
        </label>
      </div>
      <div class="checkbox checkbox--azul">
        <input :disabled="!editando" type="checkbox" id="dantaTapirtiposMamiferosMayFrec"
        v-model="form.tiposMamiferosMayFrec" value="Danta/tapir"
        v-validate="'required'" name="mamiferosFrecuentes">
        <label class="form__label" for="dantaTapirtiposMamiferosMayFrec">Danta/tapir</label>
      </div>
      <div class="checkbox checkbox--azul">
        <input :disabled="!editando" type="checkbox" id="cabroMontetiposMamiferosMayFrec"
        v-model="form.tiposMamiferosMayFrec" value="Cabro de monte"
        v-validate="'required'" name="mamiferosFrecuentes">
        <label class="form__label" for="cabroMontetiposMamiferosMayFrec">Cabro de monte</label>
      </div>
      <div class="checkbox checkbox--azul">
        <input :disabled="!editando" type="checkbox" id="venadotiposMamiferosMayFrec"
        v-model="form.tiposMamiferosMayFrec" value="Venado cola blanca"
        v-validate="'required'" name="mamiferosFrecuentes">
        <label class="form__label" for="venadotiposMamiferosMayFrec">Venado cola blanca</label>
      </div>
      <div class="checkbox checkbox--azul">
        <input :disabled="!editando" type="checkbox" id="pumaLeontiposMamiferosMayFrec"
        v-model="form.tiposMamiferosMayFrec" value="Puma/león"
        v-validate="'required'" name="mamiferosFrecuentes">
        <label class="form__label" for="pumaLeontiposMamiferosMayFrec">Puma/león</label>
      </div>
      <div class="checkbox checkbox--azul">
        <input :disabled="!editando" type="checkbox" id="jaTiPatiposMamiferosMayFrec"
        v-model="form.tiposMamiferosMayFrec" value="Jaguar/tigre/pantera"
        v-validate="'required'" name="mamiferosFrecuentes">
        <label class="form__label" for="jaTiPatiposMamiferosMayFrec">Jaguar/tigre/pantera</label>
      </div>
      <div class="checkbox checkbox--azul">
        <input :disabled="!editando" type="checkbox" id="otrotiposMamiferosMayFrec"
        v-model="form.tiposMamiferosMayFrec" value="Otro"
        v-validate="'required'" name="mamiferosFrecuentes">
        <label class="form__label" for="otrotiposMamiferosMayFrec">
          Otro / Comentarios adicionales
        </label>
      </div>
      <div class="identado">
        <form-group :error="errors.has('otro-mamifero') && submitted"
        v-if="form.tiposMamiferosMayFrec.includes('Otro')">
          <input
          data-vv-validate-on="blur"
          :disabled="!editando"
          type="text"
          class="form__input"
          v-model="form.otroMamiferosMayFrec"
          name="otro-mamifero"
          required
          v-validate="'required'">
          <label class="form__label">
            Especifique cual otro:
          </label>
        </form-group>
      </div>
    </form-group>

    <form-group :error="errors.has('hay-caceria') && submitted">
      <label class="form__label form__label--required">
        17. ¿Se da cacería o montean en la zona?
      </label>
      <div class="radio radio--azul">
        <input :disabled="!editando"
        type="radio"
        v-model="form.hayCaceria"
        id="dentroPropiedadhayCaceria"
        name="hay-caceria"
        v-validate="'required'"
        value="Dentro de la propiedad">
        <label class="form__label" for="dentroPropiedadhayCaceria">Dentro de la propiedad</label>
      </div>
      <div class="radio radio--azul">
        <input :disabled="!editando"
        type="radio"
        v-model="form.hayCaceria"
        id="alrededorhayCaceria"
        name="hay-caceria"
        v-validate="'required'"
        value="Alrededor de la propiedad (vecinos)">
        <label class="form__label" for="alrededorhayCaceria">Alrededor de la propiedad (vecinos)
        </label>
      </div>
      <div class="radio radio--azul">
        <input :disabled="!editando"
        type="radio"
        v-model="form.hayCaceria"
        id="nohayCaceria"
        name="hay-caceria"
        v-validate="'required'"
        value="No hay cacería">
        <label class="form__label" for="nohayCaceria">No hay cacería</label>
      </div>
      <div class="radio radio--azul">
        <input :disabled="!editando"
        type="radio"
        v-model="form.hayCaceria"
        id="nsnrhayCaceria"
        name="hay-caceria"
        v-validate="'required'"
        value="NS/NR">
        <label class="form__label" for="nsnrhayCaceria">NS/NR</label>
      </div>
    </form-group>

    <form-group :error="errors.has('animales-problema') && submitted">
      <label class="form__label form__label--required">
        18. Los animales silvestres que a veces le causan problemas a sus animales domésticos son:
      </label>
      <div class="checkbox checkbox--azul">
        <input :disabled="!editando" type="checkbox" id="serpientesanimalesProblema"
        v-model="form.animalesProblema" value="Serpientes" name="animales-problema"
        v-validate="'required'">
        <label class="form__label" for="serpientesanimalesProblema">Serpientes</label>
      </div>
      <div class="checkbox checkbox--azul">
        <input :disabled="!editando" type="checkbox" id="vampiroanimalesProblema"
        v-model="form.animalesProblema" value="Vampiros" v-validate="'required'"
        name="animales-problema">
        <label class="form__label" for="vampiroanimalesProblema">Vampiros</label>
      </div>
      <div class="checkbox checkbox--azul">
        <input :disabled="!editando" type="checkbox" id="coyoteanimalesProblema"
        v-model="form.animalesProblema" value="Coyote" v-validate="'required'"
        name="animales-problema">
        <label class="form__label" for="coyoteanimalesProblema">Coyote</label>
      </div>
      <div class="checkbox checkbox--azul">
        <input :disabled="!editando" type="checkbox" id="oceManianimalesProblema"
        v-model="form.animalesProblema" value="Ocelote/manigordo" v-validate="'required'"
        name="animales-problema">
        <label class="form__label" for="oceManianimalesProblema">Ocelote/manigordo</label>
      </div>
      <div class="checkbox checkbox--azul">
        <input :disabled="!editando" type="checkbox" id="pumaLeonanimalesProblema"
        v-model="form.animalesProblema" value="Puma/león" v-validate="'required'"
        name="animales-problema">
        <label class="form__label" for="pumaLeonanimalesProblema">Puma/león</label>
      </div>
      <div class="checkbox checkbox--azul">
        <input :disabled="!editando" type="checkbox" id="jaTiPaanimalesProblema"
        v-model="form.animalesProblema" value="Jaguar/tigre/pantera" v-validate="'required'"
        name="animales-problema">
        <label class="form__label" for="jaTiPaanimalesProblema">Jaguar/tigre/pantera</label>
      </div>
      <div class="checkbox checkbox--azul">
        <input :disabled="!editando" type="checkbox" id="ningunoanimalesProblema"
        v-model="form.animalesProblema" value="Ninguno" v-validate="'required'"
        name="animales-problema">
        <label class="form__label" for="ningunoanimalesProblema">Ninguno</label>
      </div>
      <div class="checkbox checkbox--azul">
        <input :disabled="!editando" type="checkbox" id="otroanimalesProblema"
        v-model="form.animalesProblema" value="Otro" v-validate="'required'"
        name="animales-problema">
        <label class="form__label" for="otroanimalesProblema">Otro / Comentarios adicionales</label>
      </div>
      <div class="identado">
        <form-group :error="errors.has('otro-animal-problema') && submitted"
        v-if="form.animalesProblema.includes('Otro')">
          <input
          data-vv-validate-on="blur"
          :disabled="!editando"
          type="text"
          class="form__input"
          v-model="form.otroAnimalesProblema"
          name="otro-animal-problema"
          required
          v-validate="'required'">
          <label class="form__label">
            Especifique cual otro:
          </label>
        </form-group>
      </div>
    </form-group>

  </form>
</template>

<script>
export default {
  name: "FormPerrosBloque3",
  props: {
    editando: Boolean,
    submitted: Boolean,
    form: Object,
  },
  methods: {
    validar,
  },
};

function validar() {
  return this.$validator.validate();
}
</script>
